import { render, staticRenderFns } from "./NoRmaRequestsFound.vue?vue&type=template&id=883043d0&"
import script from "./NoRmaRequestsFound.vue?vue&type=script&lang=js&"
export * from "./NoRmaRequestsFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports